function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCircleCheck2 = function SvgCircleCheck2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37399"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 1935",
    style: {
      stroke: "currentColor",
      strokeWidth: 2,
      fill: "transparent"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    style: {
      stroke: "none"
    },
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 19858",
    d: "m477.209 312.107 2.09 2.09 7.921-7.921",
    transform: "translate(-462.066 -289.99)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2
    }
  })));
};

export default SvgCircleCheck2;